var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0c11.046 0 20 8.954 20 20s-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0zm2.5 18.125h-5V31.25h5V18.125zM20 8.937c-.43-.004-.855.08-1.25.25-.37.16-.713.38-1.012.65a2.862 2.862 0 0 0-.907 2.126c-.012.81.317 1.587.907 2.143A3.125 3.125 0 0 0 20 15c.428.004.852-.074 1.25-.231a3.006 3.006 0 0 0 1.669-1.6 2.85 2.85 0 0 0 .25-1.2c.01-.41-.07-.817-.232-1.194a3.006 3.006 0 0 0-1.687-1.6A3.2 3.2 0 0 0 20 8.937z",
    fill: "#FFDD00",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon-info.600e1b524aaedae25f5a225e862e4f0c.svg";
export { ForwardRef as ReactComponent };